import { Component, OnInit } from "@angular/core";
import { UserData } from "apps/idl/src/model";
import { DestroyableComponentBase } from 'apps/idl/src/modules/utils/components/destroyable-component-base';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EModule } from "../../features/shared/enums/EModule";
import { DeviceService } from "../../features/shared/services/device.service";

@Component({
	selector: "di-parametres",
	templateUrl: "./parametres.page.html",
	styleUrls: ["./parametres.page.scss"],
})
export class ParametresPage extends DestroyableComponentBase implements OnInit {
	public isMobileView: boolean;
	public showMenu = true;
	public showPageDroite = false;
	public showUtilisateurs = true;
	public showCabinet: boolean = false;
	public showLecteurs: boolean = false;
	public isSCE: boolean = false;
	public isDTP: boolean = false;

	public resetUsersList$: Subject<void> = new Subject<void>();

	constructor(
		private svcDevice: DeviceService
	) {
		super();
	}

	ngOnInit() {
		this.svcDevice.isMobile$.pipe(
			takeUntil(this.destroyed$)
		).subscribe((flag: boolean) => {
			this.isMobileView = flag;
			this.updateViewForDevice();
		});

		this.initModule();
		this.updateViewForDevice();
	}

	private initModule() {
		this.isSCE = UserData.modules.includes(EModule.sce);
		this.isDTP = UserData.modules.includes(EModule.dtp);
	}

	private updateViewForDevice() {
		if (this.isMobileView) {
			this.showMenu = true;
			this.showPageDroite = false;
			this.showUtilisateurs = false;
		} else {
			this.showMenu = true;
			this.showPageDroite = this.showUtilisateurs;
			this.showUtilisateurs = true;
		}
	}

	get isUtilisateursSelected(): boolean {
		return !this.isMobileView && this.showUtilisateurs;
	}

	handleSelectionUtilisateurs() {
		if (this.isMobileView) {
			this.showMenu = false;
			this.showPageDroite = true;
		}
		this.showUtilisateurs = true;
		this.showCabinet = false;
		this.showLecteurs = false;

		this.resetUsersList$.next();
	}

	handleSelectionCabinet() {
		if (this.isMobileView) {
			this.showMenu = false;
			this.showPageDroite = true;
		}
		this.showUtilisateurs = false;
		this.showCabinet = true;
		this.showLecteurs = false;
	}

	handleSelectionLecteurs() {
		if (this.isMobileView) {
			this.showMenu = false;
			this.showPageDroite = true;
		}
		this.showUtilisateurs = false;
		this.showCabinet = false;
		this.showLecteurs = true;
	}

	handleRetourParametres = () => {
		this.showPageDroite = false;
		this.showMenu = true;
	}
}
